import React from 'react';
import { CollectionState, FiltersMap } from '@wix/bex-core';
import { InfiniteScrollTableVirtual } from './InfiniteScrollTableVirtual';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CollectionTableBaseProps } from '../CollectionTable';
import { InfiniteScrollTableState } from '../../state';
import { InfiniteScrollTableCompat } from './InfiniteScrollTableCompat';

export interface InfiniteScrollTableProps<T, F extends FiltersMap>
  extends CollectionTableBaseProps<T, F> {
  rowHeight?: number | ((item: T, index: number) => number);
  estimatedRowHeight?: number;
  state: CollectionState<T, F> | InfiniteScrollTableState<T, F>;

  // a flag to opt out from virtualization
  isVirtual?: boolean;
}

export function InfiniteScrollTable<T, F extends FiltersMap = FiltersMap>(
  props: InfiniteScrollTableProps<T, F>,
) {
  const { rowHeight, estimatedRowHeight, isVirtual, ...tableProps } = props;
  const container = useWixPatternsContainer();

  const { internalExperiments } = container;

  const isVirtualExperiment = internalExperiments?.enabled(
    'specs.Cairo.TableVirtualizationAsDefault',
  );

  return isVirtualExperiment && isVirtual !== false && !props.rowDetails ? (
    <InfiniteScrollTableVirtual
      {...tableProps}
      rowHeight={rowHeight}
      estimatedRowHeight={estimatedRowHeight}
    />
  ) : (
    <InfiniteScrollTableCompat {...tableProps} />
  );
}

export { InfiniteScrollTableProps as TableProps };
export { InfiniteScrollTable as Table };
